export const AUTOMATION_HISTORIES_LOAD = 'AUTOMATION_HISTORIES_LOAD'
export const AUTOMATION_HISTORIES_LOAD_PENDING = 'AUTOMATION_HISTORIES_LOAD_PENDING'
export const AUTOMATION_HISTORIES_LOAD_FULFILLED = 'AUTOMATION_HISTORIES_LOAD_FULFILLED'
export const AUTOMATION_HISTORIES_LOAD_REJECTED = 'AUTOMATION_HISTORIES_LOAD_REJECTED'

export const AUTOMATION_HISTORY_LOAD = 'AUTOMATION_HISTORY_LOAD'
export const AUTOMATION_HISTORY_LOAD_PENDING = 'AUTOMATION_HISTORY_LOAD_PENDING'
export const AUTOMATION_HISTORY_LOAD_FULFILLED = 'AUTOMATION_HISTORY_LOAD_FULFILLED'
export const AUTOMATION_HISTORY_LOAD_REJECTED = 'AUTOMATION_HISTORY_LOAD_REJECTED'
